import { memo, useContext } from "react";
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaTiktok } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

import { Link, useLocation } from "react-router-dom";
import { Container } from "reactstrap";
import AgrogridBrandLogo from "../../assets/images/agrogrid-brand.png";
import { Wrapper } from "./footer.styles";
import { CONTACT_MODAL_TYPES, ContactUsContext } from "../../providers/contactUs.provider";

const footerGroups = [
  { title: "For Households", links: [["Split Buy", "/split-buy"], ["Market Prices", "/market-prices"]] },
  { title: "For Farmers", links: [["Our Farms", "/farms"], ["Featured Farms", "/farms"], ["Farm Spotlights", "/farms"]] },
  { title: "For Businesses", links: [["B2B Sourcing", "/businesses"], ["Contact Sales", "/businesses"]] },
  { title: "Company", links: [["About Us", "/#our-story"], ["Blog", "/blog"]] },
];

export const FooterComponent = memo(() => {
  const location = useLocation();
  const { openContactModal } = useContext(ContactUsContext);
  const hideFooter = location.pathname.startsWith("/cart") || location.pathname.startsWith("/guest-sign-in") || location.pathname.startsWith("/admin/internal") || location.pathname === "/rate-order";

  if (hideFooter) return null;

  return (
    <Wrapper>
      <Container className="footer-content">
        <div className="footer-primary">
          <div className="footer-brand">
            <Link to="/" aria-label="Agrogrid home"><img src={AgrogridBrandLogo} alt="Agrogrid" /></Link>
            <p>The farm-to-market supply network connecting farmers, businesses and families across Nigeria with fresh produce at fair prices.</p>
          </div>

          <nav className="footer-links" aria-label="Footer navigation">
            {footerGroups.map((group) => (
              <section key={group.title}>
                <strong>{group.title}</strong>
                {group.links.map(([label, to]) => label === "Contact Sales"
                  ? <button key={label} type="button" className="footer-link" onClick={() => openContactModal(CONTACT_MODAL_TYPES.BUSINESS_PRICING)}>{label}</button>
                  : <Link key={label} to={to}>{label}</Link>)}
              </section>
            ))}
          </nav>
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} Agrogrid. All rights reserved.</p>
          <div className="footer-legal">
            <Link to="/terms-and-conditions">Terms of Service</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/refund-policy">Refund Policy</Link>
          </div>
          <div className="footer-socials">
            <a href="https://www.linkedin.com/company/agrogrid" target="_blank" rel="noreferrer" aria-label="Agrogrid on LinkedIn"><FaLinkedinIn /></a>
            <a href="https://x.com/agrogrid" target="_blank" rel="noreferrer" aria-label="Agrogrid on Instagram"><FaXTwitter /></a>
            <a href="https://www.facebook.com/p/AgroGrid-100089865710096/" target="_blank" rel="noreferrer" aria-label="Agrogrid on Facebook"><FaFacebookF /></a>
            <a href="https://www.instagram.com/agro_grid/" target="_blank" rel="noreferrer" aria-label="Agrogrid on Instagram"><FaInstagram /></a>
            <a href="https://www.tiktok.com/@agro_grid" target="_blank" rel="noreferrer" aria-label="Agrogrid on Instagram"><FaTiktok /></a>
          </div>
        </div>
      </Container>
      <span className="footer-watermark" aria-hidden="true">Agrogrid</span>
    </Wrapper>
  );
});
